import { createContext } from "react";

const EliteJobContext = createContext();

export default EliteJobContext;
